export function RoleChecker(
  roleSpected:
    | "SuperAdmin"
    | "Admin"
    | "Manager"
    | "AfterSale"
    | "SalesAdvisor"
    | "CommunityManager"
    | "OfficeSalesAdvisor"
    | "CreditManager"
) {
  const role = localStorage.getItem("rol");
  if (!role) return false;

  return role === roleSpected;
}
